var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKingyellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 24,
    viewBox: "0 0 21 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.625 1.125C11.625 0.501562 11.1234 0 10.5 0C9.87656 0 9.375 0.501562 9.375 1.125V2.625H7.875C7.25156 2.625 6.75 3.12656 6.75 3.75C6.75 4.37344 7.25156 4.875 7.875 4.875H9.375V6.75H2.79375C1.25156 6.75 0 8.00156 0 9.54375C0 9.92813 0.0796875 10.3078 0.229688 10.6594L2.77031 16.5H5.22188L2.29688 9.75937C2.26875 9.68906 2.25 9.61875 2.25 9.54375C2.25 9.24375 2.49375 9 2.79375 9H10.5H18.2062C18.5062 9 18.75 9.24375 18.75 9.54375C18.75 9.61875 18.7359 9.69375 18.7031 9.75937L15.7734 16.5H18.225L20.7656 10.6594C20.9203 10.3078 20.9953 9.92813 20.9953 9.54375C20.9953 8.00156 19.7437 6.75 18.2016 6.75H11.625V4.875H13.125C13.7484 4.875 14.25 4.37344 14.25 3.75C14.25 3.12656 13.7484 2.625 13.125 2.625H11.625V1.125ZM4.74375 20.25H16.2562L17.0344 21.75H3.97031L4.74844 20.25H4.74375ZM18.0422 18.8109C17.7844 18.3141 17.2687 18 16.7109 18H4.28906C3.72656 18 3.21562 18.3141 2.95781 18.8109L1.71562 21.2109C1.575 21.4828 1.5 21.7828 1.5 22.0875C1.5 23.1469 2.35313 24 3.4125 24H17.5875C18.6422 24 19.5 23.1469 19.5 22.0875C19.5 21.7828 19.425 21.4828 19.2844 21.2109L18.0422 18.8109Z",
    fill: "#FFCD05"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKingyellow);
export default __webpack_public_path__ + "static/media/King yellow.51d68e7cf29bc61899a9ac260471a846.svg";
export { ForwardRef as ReactComponent };